import {UISidebarController} from '../../../ui_html/sidebar/UISidebarController'

export class UIDFAQSceneController {
    private readonly sidebarController: UISidebarController
    private readonly faqSceneContainerDiv: HTMLDivElement

    constructor(sidebarController: UISidebarController) {
        this.sidebarController = sidebarController
        this.faqSceneContainerDiv = document.getElementById('scene_discord_faq_container') as HTMLDivElement
    }

    hide() {
        this.faqSceneContainerDiv.classList.add('hidden')
    }

    show() {
        this.faqSceneContainerDiv.classList.remove('hidden')
        this.sidebarController.deactivateAllButtons()
    }
}
